module.exports = __webpack_public_path__ + "img/wanhai.432526a2.png";